// AGC: Admin Panel - Editable Slider Component
// AGC: Slider with synchronized numeric input for precise value editing

import React from 'react'

interface EditableSliderProps {
  label: string
  value: number
  min: number
  max: number
  step?: number
  unit: string
  description?: string
  onChange: (value: number) => void
}

/**
 * AGC: EditableSlider - Combined slider and number input
 * AGC: Provides both visual and precise numeric control for parameters
 */
export const EditableSlider: React.FC<EditableSliderProps> = ({
  label,
  value,
  min,
  max,
  step = 1,
  unit,
  description,
  onChange,
}) => (
  <div className="mb-6">
    <div className="flex justify-between items-center mb-2">
      <label className="text-sm font-medium text-slate-700 dark:text-slate-300">{label}</label>
      <div className="flex items-center gap-2">
        <input
          type="number"
          value={value}
          min={min}
          max={max}
          step={step}
          onChange={(e) => onChange(Number(e.target.value))}
          className="w-20 px-3 py-1.5 border border-slate-200 dark:border-white/5 rounded-lg text-right text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent"
        />
        <span className="text-sm text-slate-500 dark:text-slate-400 min-w-[30px]">{unit}</span>
      </div>
    </div>
    <input
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className="w-full h-2 bg-slate-200 dark:bg-white/10 rounded-full appearance-none cursor-pointer accent-green-500"
    />
    <div className="flex justify-between mt-1">
      <span className="text-xs text-slate-400 dark:text-slate-500">{min}{unit}</span>
      <span className="text-xs text-slate-400 dark:text-slate-500">{max}{unit}</span>
    </div>
    {description && (
      <p className="text-xs text-slate-500 dark:text-slate-400 mt-2 italic">{description}</p>
    )}
  </div>
)

export default EditableSlider


